module.exports = __webpack_public_path__ + "pm.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/pm.svg
// module id = 761
// module chunks = 0